import { render, staticRenderFns } from "./voucherSendDlg.vue?vue&type=template&id=56be1203&scoped=true"
import script from "./voucherSendDlg.vue?vue&type=script&lang=js"
export * from "./voucherSendDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be1203",
  null
  
)

export default component.exports